import { render, staticRenderFns } from "./CargaControlInventario.vue?vue&type=template&id=4ffb5806&"
import script from "./CargaControlInventario.vue?vue&type=script&lang=js&"
export * from "./CargaControlInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports